export default{
    setRecentNews(state, payload){
        state.recentNews = payload
    }
}